import React, { useState, useEffect } from 'react';

const StatusBar = ({ isSystemOnline, isProduction }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the status bar after a delay (e.g., 2 seconds)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full bg-slate-900/60 backdrop-blur-sm border border-slate-800/60 rounded-lg p-2 1xl:p-4 mb-2 1xl:mb-4 animate-in fade-in slide-in-from-top duration-300">
      <div className="flex items-center justify-center gap-4 2xl:gap-8">
        <div className="flex items-center gap-2">
          <span className="text-xs 2xl:text-sm text-slate-400">
            System Status:
          </span>
          <span
            className={`px-2 2xl:px-3 py-0.5 2xl:py-1 rounded-full flex items-center gap-1.5 ${
              isSystemOnline
                ? "bg-emerald-500/10 text-emerald-400"
                : "bg-red-500/10 text-red-400"
            } text-xs 2xl:text-sm font-medium`}
          >
            <span
              className={`h-1.5 w-1.5 2xl:h-2 2xl:w-2 rounded-full ${
                isSystemOnline
                  ? "bg-emerald-400 animate-pulse"
                  : "bg-red-400"
              }`}
            />
            {isSystemOnline ? "ON" : "OFF"}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs 2xl:text-sm text-slate-400">
            Production:
          </span>
          <span
            className={`px-2 2xl:px-3 py-0.5 2xl:py-1 rounded-full flex items-center gap-1.5 ${
              isProduction
                ? "bg-green-500/10 text-green-400"
                : "bg-red-500/10 text-red-400"
            } text-xs 2xl:text-sm font-medium`}
          >
            <span
              className={`h-1.5 w-1.5 2xl:h-2 2xl:w-2 rounded-full ${
                isProduction ? "bg-green-400 animate-pulse" : "bg-red-400"
              }`}
            />
            {isProduction ? "ON" : "OFF"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;